import { monthNames } from './constants';

export const decimalFormattedNumber = (value) => value.toString().replace('.', ' ');

export const getMonthName = (month: number) => {
  if (!month || month > 12) return '';

  return monthNames[month - 1].toUpperCase();
};
